<!--
 * @Author: yank 471973511@qq.com
 * @Date: 2025-03-28 15:47:03
 * @LastEditors: The_xu 2596841393@qq.com
 * @LastEditTime: 2026-02-05 11:21:18
 * @FilePath: /yda-qywx-h5/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div
    :style="{
      '--dynamic-padding-top': dynamicPaddingTop,
      '--dynamic-padding-bottom': dynamicPaddingBottom
    }"
    :class="['layout_container', isApp && 'app_layout_container', $route.meta.darkMode && isYKY && 'dark-mode-bg']"
  >
    <PadHead v-if="!isResizeMobile && $route.name !== 'loginPC'"></PadHead>
    <Head v-if="getShow" style="flex-shrink: 0"></Head>
    <div :class="[getShow ? 'fll' : '', 'abc']" id="yky-custom">
      <router-view :style="[$route.meta.rootHeightFill && 'height:100%']" v-slot="{ Component }">
      <KeepAlive :include="cacheRouteList">
        <component :is="Component" :key="$route.fullPath"/>
      </KeepAlive>
    </router-view>
    <!-- <router-view :key="$route.fullPath" v-if="!$route.meta.keepAlive"></router-view> -->
    </div>
  </div>
</template>

<script setup>
import { xda } from '@hybird/flutter'
import { Device, DeviceInfo } from '@hybird/device'
import Head from '@/components/head/index.vue'
import { useRoute } from 'vue-router'
import { computed, ref, provide, onMounted } from 'vue'
import router from './router'
import { environmentJudge, APP,YKY, DINGTALK, QYWX, FEISHU } from '@/utils/utils.js'
import { initJPush, getBadge } from '@/utils/jpush'
import { usePageResizeStore } from '@/store/pageResize'
const pageResizeStore = usePageResizeStore()
const isResizeMobile = computed(() => pageResizeStore.isMobile)
import { getDeviceInfo, userLogout } from '@/utils/env'
import { useDeviceStore } from '@/store/home'
import { logoutApi } from '@/api/me/me.js'
import { onUnmounted } from 'vue'
import { watch } from 'vue'

const cacheRouteList = ref(['approveDetails'])
provide('cacheRouteList', cacheRouteList)

const isApp = environmentJudge() == APP
const isYKY = environmentJudge() == YKY
// 创建响应式回调引用
const currentGoBack = ref(() => {
  router.back()
})
const paddingTopValue = ref(0)
const paddingBottomValue = ref(0)
// 提供修改方法给子组件
provide('updateGoBack', (newGoBack) => {
  currentGoBack.value =
    newGoBack == null
      ? () => {
          router.back()
        }
      : newGoBack
})
// 新增：提供执行方法
provide('executeGoBack', () => {
  currentGoBack.value()
})
const route = useRoute()
if (import.meta.env.VITE_IS_HTTPS == 'true' && environmentJudge() != APP) {
  const protocolStr = document.location.protocol
  if (protocolStr === 'http:') {
    window.location.href = 'https://' + document.location.host
  }
}
// 头部标题是否显示
const getShow = computed(() => {
  return !route.meta.headHidden && environmentJudge() == APP
})
// 新增计算paddingTop的方法
const dynamicPaddingTop = computed(() => {
  return Number(paddingTopValue.value)
})
// 新增计算paddingBottom的方法
const dynamicPaddingBottom = computed(() => {
  return Number(paddingBottomValue.value)
})
// 获取设备信息中的padding.top值，赋值给paddingTopValue.value
const getPaddingTop = async () => {
  if (environmentJudge() == APP) {
    console.log('jlklklkl', environmentJudge(), '111')
    const info = getDeviceInfo()
    console.log('-------1111', JSON.stringify(info))
    paddingTopValue.value = info?.padding?.top || 0
    paddingBottomValue.value = info?.padding?.bottom || 0
    console.log(JSON.stringify(info), 'devicesInfo')
  }
}

const deviceStore = useDeviceStore()
let logoutTimer = null
const TIMEOUT = process.env.newConnect ? 86400 * 1000 : 120 * 1000 // 2 minutes

const handleAutoLogout = async () => {
  const sessionId = localStorage.getItem('sessionId')
  if (!sessionId) return

  if (deviceStore.isConnect) {
    resetLogoutTimer()
    return
  }

  try {
    await logoutApi({ json: 1 })
  } catch (e) {
    console.warn('Logout API failed', e)
  }

  await userLogout()
  const url = '/loginAccount'
  router.replace({ path: url })
}

const resetLogoutTimer = () => {
  console.log('resetLogoutTimer')
  if (logoutTimer) clearTimeout(logoutTimer)
  logoutTimer = setTimeout(handleAutoLogout, TIMEOUT)
}

const initAutoLogout = () => {
  const events = ['click', 'touchstart', 'mousemove', 'keydown']
  events.forEach(event => {
    window.addEventListener(event, resetLogoutTimer)
  })
  resetLogoutTimer()
}

const removeAutoLogout = () => {
  const events = ['click', 'touchstart', 'mousemove', 'keydown']
  events.forEach(event => {
    window.removeEventListener(event, resetLogoutTimer)
  })
  if (logoutTimer) clearTimeout(logoutTimer)
}

const stopWatchConnect = watch(() => deviceStore.isConnect, (val) => {
  if (environmentJudge() == YKY && val === false) resetLogoutTimer()
})

onMounted(async () => {
  getPaddingTop()
  if (environmentJudge() == APP) {
    initJPush(router)
    const sessionId = localStorage.getItem('sessionId')
    if (sessionId) {
      getBadge()
    }
  }
  pageResizeStore.onListenerResize()
  if (environmentJudge() == YKY){
    initAutoLogout()
  }
})

onUnmounted(() => {
  if (environmentJudge() == YKY) {
    removeAutoLogout()
  }
  stopWatchConnect()
})
</script>

<style lang="less">
body {
  font-family: PingFangSC-Regular, PingFang SC;
}

.layout_container {
  /* 新增头部padding处理 */
  /* 同时支持新旧语法 */
  // padding-top: constant(safe-area-inset-top);
  // padding-top: env(safe-area-inset-top);

  display: flex;
  flex-direction: column;
  height: 100vh;

  .abc {
    flex: 1;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }
  }
  .fll {
    top: inherit !important;
  }
}

.dark-mode-bg {
  background-image: url('@/assets/images/dark-mode.png') !important;
  background-position: center !important;
  background-size: cover !important;
  background-position: center !important; 
  background-repeat: no-repeat !important;
}

.app_layout_container {
  // .mixin-custom-style-safe-basic(@paddingBottom,0rem);
  .van-image-preview__close-icon {
    .mixin-custom-style-safe(@top,@dynamicPaddingTop,var(--van-image-preview-close-icon-margin));
  }

  .van-image-preview__index {
    .mixin-custom-style-safe(@top,@dynamicPaddingTop,var(--van-padding-md));
  }
}
</style>
